// localStorage存储token的固定key
const TOKEN_KEY = 'token'
// localStorage存储账户信息的固定key
const USER = 'user'

// 获取token
export function getToken() {
	return localStorage.getItem(TOKEN_KEY)
}

// 存储token
export function setToken(tokenValue) {
	if (!tokenValue) return
	localStorage.setItem(TOKEN_KEY, tokenValue)
}

// 删除token
export function removeToken() {
	localStorage.removeItem(TOKEN_KEY)
}





// 获取user
export function getUser() {
	return localStorage.getItem(USER)
}
// 存储user
export function setUser(userValue) {
	if (!userValue) return
	localStorage.setItem(USER, userValue)
}
// 删除uer
export function removeUser() {
	localStorage.removeItem(USER)
}